import { useEffect, useState } from "react";
import { getLogger } from "lib/tracking/getLogger";
import { GreenhouseDepartment } from "../types";
import { mergeSortDepartments } from "../utils";

const GREENHOUSE_BOARD_URLS = [
  "https://boards-api.greenhouse.io/v1/boards/guideline/departments",
  "https://boards-api.greenhouse.io/v1/boards/guidelineexternal/departments",
];

async function fetchData(url: string) {
  return (await fetch(url)).json();
}

function useOpenRoles() {
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState<GreenhouseDepartment[]>([]);
  const logger = getLogger("hooks:useOpenRoles");

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const boards = await Promise.all(GREENHOUSE_BOARD_URLS.map((url) => fetchData(url)));

        const mergedDepartments = mergeSortDepartments(boards);

        setDepartments(mergedDepartments);
        setLoading(false);
      } catch (error) {
        logger.error(error);
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  return { departments, loading };
}

export { useOpenRoles };
